import { asyncRoutes as asyncRoutesPaycools, constantRoutes as constantRoutesPaycools } from '@/router/paycools'
import { asyncRoutes as asyncRoutesMoneypay, constantRoutes as constantRoutesMoneypay } from '@/router/ezpay'

let asyncRoutes
let constantRoutes
if (['paycools', 'moneypay', 'id', 'mx'].includes(process.env.VUE_APP_PLATFORM)) {
  asyncRoutes = asyncRoutesPaycools
  constantRoutes = constantRoutesPaycools
}

if (process.env.VUE_APP_PLATFORM === 'ezpay') {
  asyncRoutes = asyncRoutesMoneypay
  constantRoutes = constantRoutesMoneypay
}
if (process.env.VUE_APP_PLATFORM === 'aruxpay') {
  asyncRoutes = asyncRoutesMoneypay
  constantRoutes = constantRoutesMoneypay
}

import { cloneDeep } from 'lodash'

function filterRoutes(authorities) {
  const routerMap = cloneDeep(asyncRoutes)
  // 如果有代理权限，只展示代理相关的页面
  if (authorities.includes('ROLE_AUTH_AGENT_ADMIN')) {
    return routerMap.filter(item => {
      if (!item) {
        return
      }

      if (!item.children) {
        return item
      }
      let hidden = true
      item.children = item.children.filter(child => {
        if (!child.meta.auth) {
          child.hidden = true
        }
        if (child.meta.auth && child.meta.auth.includes('ROLE_AUTH_AGENT_ADMIN')) {
          hidden = false
          return true
        }
      })
      item.hidden = hidden
      if (item.name === 'System_Manage') {
        item.hidden = true
      }
      return item
    })
  }

  return routerMap.filter(item => {
    if (!item) {
      return
    }
    if (!item.children) return item
    let hidden = true
    item.children = item.children.filter(child => {
      if (child.meta.auth && Array.isArray(child.meta.auth)) {
        const instersect = child.meta.auth.filter(auth => authorities.indexOf(auth) > -1)

        if (instersect.length === 0) {
          child.auth_hidden = true
          return false
          // child.hidden = true
        } else {
          child.auth_hidden = false
          if (!child.hidden) hidden = false
        }
      } else {
        child.hidden = true
      }
      if (process.env.NODE_ENV === 'production' && ['System_simulation_payment', 'System_simulation_payout'].indexOf(child.name) !== -1) {
        return false
      }

      return child
    })
    item.hidden = hidden

    return item
  })
}

const permission = {
  state: {
    routes: [],
    addRoutes: []
  },
  mutations: {
    SET_ROUTES: (state, routes) => {
      state.addRoutes = routes
      state.routes = constantRoutes.concat(routes)
    },
    RESET_ROUTES: (state, routes) => {
      state.addRoutes = routes
      state.routes = routes
    }
  },
  actions: {
    generateRoutes({ commit, rootState }, data) {
      return new Promise(resolve => {
        const { authorities, country_code } = data
        commit('RESET_ROUTES', [])
        let newAuthorities = authorities
        const asyncRoute = asyncRoutes
        if (country_code === 'MY') {
          newAuthorities = newAuthorities.filter(item => !['AUTH_CODE_LARGE_CREATE_DISBURSEMENT', 'AUTH_CODE_LARGE_AMOUNT'].includes(item))
        }
        if (country_code === 'ID') {
          newAuthorities = newAuthorities.filter(item => !['AUTH_CODE_LARGE_CREATE_DISBURSEMENT', 'AUTH_CODE_LARGE_AMOUNT'].includes(item))
        }
        if (rootState.app.isPii && !['ID'].includes(country_code)) {
          newAuthorities = newAuthorities.filter(item => !['AUTH_CODE_PAYMENT_LINK'].includes(item))
        }

        const accessedRoutes = filterRoutes(newAuthorities)

        commit('SET_ROUTES', accessedRoutes)
        resolve(accessedRoutes)

        // commit('SET_ROUTES', asyncRoutes)
        // resolve(asyncRoutes)
      })
    }
  }
}

export default permission
